import {
  GET_CUSTOMER_CARDS,
  DELETE_CARD_DETAILS_SUCCESS,
} from '../../actions/types';

const initialState = {
  customerCards: []
};

const getCards = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_CARDS:
      return {
        ...state,
        customerCards: action.cards
      };
    case DELETE_CARD_DETAILS_SUCCESS:
      return state.customerCards.customerCards.filter(item => item.id !== action.cardId);
    default: return state;
  }
};

export default getCards;
